<template>
    <div class="control">
        <label>{{$t('comp.assetModal.controls.wayOfDispose.label')}}</label>

        <csa-select
                v-model="selected"
                @open="opened"
                :options="options"
                trackBy="id"
                label="name"
                @tag="create"
                :taggable="$app.user.role === 'mcs'"
                :tag-placeholder="$t('comp.assetModal.controls.wayOfDispose.selectPlaholder')"
        >
        </csa-select>
    </div>
</template>

<script>
    import CsaSelect from 'Controls/CsaMultiSelect.vue'
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: "asset-wayOfDispose-control",
        components: {
            CsaSelect
        },
        data() {
            return {
                selected: null
            };
        },
        props: {
            value: null
        },
        watch: {
            selected: function (v) {
                this.$emit('input', v);
            },
            value: function (v) {
                if (Number.isInteger(v)) {
                    v = this.getById(v);
                }
                this.selected = v;
            }
        },
        created(){
            this.fetchWayOfDisposes();
            this.selected = this.value;
        },
        computed: {
            ...mapGetters("assetWayOfDispose", {
                options: "getWayOfDisposes",
                getById: "getWayOfDisposeById"
            }),
        },
        methods: {
            ...mapActions("assetWayOfDispose", ["fetchWayOfDisposes", "addWayOfDispose"]),
            create: function (name) {
                this.addWayOfDispose(name).then((wayOfDispose) => {
                    this.selected = wayOfDispose;
                });
            }
        }
    }
</script>